import { useMemo } from 'react'
import { useModelStore } from '@editor/stores'

type StoreyElementTypeToOpacity = Record<string, Partial<Record<ElementTypes, number>>>

const useStoreyToElementTypeToOpacity = (storey: string | null | undefined) => {
  const visibleStoreys = useModelStore(state => state.visibleStoreys)

  const storeyToElementTypeAndOpacity = useMemo<StoreyElementTypeToOpacity | undefined>(() => {
    if (!storey) return undefined

    const elementTypesForOpacity: ElementTypes[] = [
      'outer_walls',
      'inner_walls',
      'slabs',
      'roof_slabs',
      'vertical_slabs',
      'vertical_roof_slabs',
      'beams',
      'purlins',
      'columns',
      'rips',
      'lintels',
      'slab_beams',
      'roof_slab_beams',
      'standard_rips',
      'foundation',
    ]

    const storeyToBaseOpacity = Array.from(visibleStoreys).reduce<Record<string, number>>(
      (acc, s) => {
        acc[s] = s === storey ? 1 : 1
        return acc
      },
      {},
    )

    return Object.fromEntries(
      Object.entries(storeyToBaseOpacity).map(([s, baseOpacity]) => [
        s,
        elementTypesForOpacity.reduce<Partial<Record<ElementTypes, number>>>((acc, elementType) => {
          if (elementType === 'slabs') {
            acc[elementType] = 0.2
          } else if (elementType === 'roof_slabs') {
            acc[elementType] = 0.25
          } else if (elementType === 'vertical_slabs') {
            acc[elementType] = 0.5
          } else if (elementType === 'vertical_roof_slabs') {
            acc[elementType] = 0.25
          } else if (elementType === 'columns') {
            acc[elementType] = 0.2
          } else if (elementType === 'rips') {
            acc[elementType] = 0.2
          } else {
            acc[elementType] = baseOpacity
          }

          return acc
        }, {}),
      ]),
    ) as StoreyElementTypeToOpacity
  }, [visibleStoreys, storey])

  return storeyToElementTypeAndOpacity
}

export default useStoreyToElementTypeToOpacity
